var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ECG_CHANNELS, ECG_DISPLAY_OPTIONS, } from '../';
import { GenericCanvasClass, CANVAS_DEFAULT_VALUES } from './GenericCanvasClass';
import { getSampleGridHeight, getSampleGridWidth, getSampleWidthInSeconds } from './getSampleSize';
export var CANVAS_INITIAL_SCALE = 1;
export var CANVAS_INITIAL_DRAW_POINT = 1;
export var CANVAS_MIDDLE_FACTOR = 2;
export var CANVAS_ABSOLUTE_VALUE = 100;
export var CANVAS_MIN_SCALE_FACTOR = 3.8;
export var CANVAS_MIN_CURVE_WIDTH_FACTOR = 0.5;
export var CANVAS_MAX_CURVE_WIDTH_FACTOR = 1.5;
export var CANVAS_DELTA_CURVE_WIDTH_FACTOR = 0.2;
export var CANVAS_MINIMAL_OPERATIONAL_VALUE = 1.0;
export var MARGIN_COLUMN_GAP = 10;
export var PAN_SCROLL_FACTOR = 10;
export var INITIAL_FRECUENCY_POINT = 0.05;
export var FULL_WIDTH_BLOCKS = 250;
export var SAMPLE_START_OFFSET = 5;
//Global variable for pan and drag:
//The global variable is necessary since we have to remove an event listener that we call from 2 places in the same class.
var pan = {
    start: { x: null, y: null },
    offset: { x: 0, y: 0 },
    globalOffset: { x: 0, y: 0 },
};
/**
 * Draw grid canvas template.
 */
var DrawECGCanvasClass = /** @class */ (function (_super) {
    __extends(DrawECGCanvasClass, _super);
    function DrawECGCanvasClass(id_canvas, dataMg, display, channelsData) {
        var _this = _super.call(this, id_canvas, dataMg) || this;
        _this.margin = 20; //Margin to draw elements.
        _this.changeValues = 0.05; //Value of change up down, left o right graph.
        _this.scale = CANVAS_INITIAL_SCALE;
        _this.scaleFactor = 0.8;
        _this.startToDrawPoint = CANVAS_INITIAL_DRAW_POINT;
        _this.channelsData = [];
        _this.canvasPan = pan;
        _this.display = ECG_DISPLAY_OPTIONS['2x5'];
        //Reset values pan:
        _this.canvasPan.start.x = null;
        _this.canvasPan.start.y = null;
        _this.canvasPan.offset.x = 0;
        _this.canvasPan.offset.y = 0;
        _this.canvasPan.globalOffset.x = 0;
        _this.canvasPan.globalOffset.y = 0;
        //Display:
        if (display)
            _this.display = display;
        var orderedData = _this.getOrderData(display, channelsData);
        _this.channelsData = orderedData;
        return _this;
    }
    DrawECGCanvasClass.prototype.getOrderData = function (display, channelsData) {
        if (display === ECG_DISPLAY_OPTIONS['4x2.5r']) {
            //the name of the channel can be diferent
            var orderedChannels = [
                channelsData[0],
                channelsData[3],
                channelsData[6],
                channelsData[9],
                channelsData[1],
                channelsData[4],
                channelsData[7],
                channelsData[10],
                channelsData[2],
                channelsData[5],
                channelsData[8],
                channelsData[11], //v6
            ];
            return orderedChannels.filter(function (channel) { return channel; }); // Filter undefined channels
        }
        return channelsData;
    };
    //--------------------------------------------------------
    //------------------ DRAW AND EVENTS ---------------------
    //--------------------------------------------------------
    //#region DRAW AND EVENTS:
    /**
     * Draw grid and views.
     * We don't put requestAnimationFrame since it only renders when we zoom, redraw or move, that's why I don't put the method to be loading all the time without need.
     */
    DrawECGCanvasClass.prototype.draw = function () {
        if (this.configuration.FULL_WIDTH) {
            this.configuration.CELL_SIZE = this.width / FULL_WIDTH_BLOCKS;
        }
        else {
            this.configuration.CELL_SIZE = CANVAS_DEFAULT_VALUES.CELL_SIZE;
        }
        this.configuration.BLOCK_SIZE = this.configuration.CELL_SIZE * 5;
        this.context.setTransform(1, 0, 0, 1, 0, 0);
        //Zoom:
        this.context.scale(this.scale, this.scale);
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        //Pan:
        this.context.translate(this.canvasPan.offset.x, this.canvasPan.offset.y);
        //Draw:
        this.drawGrid();
        this.drawECGIndicators();
        this.drawDelimiterLines();
        this.drawECG();
    };
    /**
     * Load view no compatible:
     */
    DrawECGCanvasClass.prototype.drawNoCompatible = function () {
        this.context.font = '3rem Arial';
        this.context.fillText('ECG NO COMPATIBLE', this.canvas.width / 2, this.canvas.height / 2);
    };
    /**
     * Change zoom, scale canvas, and adjust line stroke.
     * @param min minimize or maximize
     */
    DrawECGCanvasClass.prototype.changeZoom = function (min) {
        //Zoom:
        if (min) {
            this.scale *= this.scaleFactor;
            if (this.configuration.CURVE_WIDTH < CANVAS_MIN_CURVE_WIDTH_FACTOR && this.scale < CANVAS_MIN_SCALE_FACTOR) {
                this.configuration.CURVE_WIDTH += CANVAS_DELTA_CURVE_WIDTH_FACTOR;
            }
        }
        else {
            this.scale /= this.scaleFactor;
            if (this.configuration.CURVE_WIDTH > CANVAS_MAX_CURVE_WIDTH_FACTOR) {
                this.configuration.CURVE_WIDTH -= CANVAS_DELTA_CURVE_WIDTH_FACTOR;
            }
        }
        //Max undefinded and min zoom = zoom base:
        if (this.scale <= CANVAS_INITIAL_SCALE) {
            this.scale = CANVAS_INITIAL_SCALE;
            this.draw();
        }
        else {
            this.draw();
        }
    };
    /**
     * Change amplitude
     * Amplutud value will change it's value 5 by 5
     * To avoid unwanted behavior the minimal value its 5mm/mV and the maximun value its 100mm/mV
     * @param up up or down.
     */
    DrawECGCanvasClass.prototype.changeAmplitude = function (up) {
        var ampli;
        if (up) {
            ampli = this.configuration.AMPLITUDE + this.changeValues;
        }
        else {
            ampli = this.configuration.AMPLITUDE - this.changeValues;
        }
        ampli = getRoundedValue(ampli);
        //Max 1.0 = 100mm/mV | min 0.05 = 5mm/mV
        if (ampli <= CANVAS_MINIMAL_OPERATIONAL_VALUE && ampli >= this.changeValues) {
            //Change amplitude:
            this.amplitude = ampli;
            this.draw();
        }
    };
    DrawECGCanvasClass.prototype.changeXAxis = function (left) {
        var xValue;
        if (left) {
            xValue = this.canvasPan.offset.x - PAN_SCROLL_FACTOR;
        }
        else {
            xValue = this.canvasPan.offset.x + PAN_SCROLL_FACTOR;
        }
        this.canvasPan.offset.x = xValue;
        this.draw();
    };
    DrawECGCanvasClass.prototype.setXAxis = function (value) {
        this.canvasPan.offset.x = value;
        this.draw();
    };
    DrawECGCanvasClass.prototype.setYAxis = function (value) {
        this.canvasPan.offset.y = value;
        this.draw();
    };
    DrawECGCanvasClass.prototype.changeYAxis = function (down) {
        var yValue;
        if (down) {
            yValue = this.canvasPan.offset.y - PAN_SCROLL_FACTOR;
        }
        else {
            yValue = this.canvasPan.offset.y + PAN_SCROLL_FACTOR;
        }
        this.canvasPan.offset.y = yValue;
        this.draw();
    };
    /**
     * Change tempo.
     * Tempo value will change it's value 5 by 5
     * To avoid unwanted behavior the minimal value its 5mm/s and the maximun value its 100mm/s
     * @param left left or right
     */
    DrawECGCanvasClass.prototype.changeTempo = function (left) {
        var time;
        if (left) {
            time = this.configuration.TIME - this.changeValues;
        }
        else {
            time = this.configuration.TIME + this.changeValues;
        }
        time = getRoundedValue(time);
        //Max 1.0 = 100mm/ss | min 0.5 = 5mm/ss
        if (time <= CANVAS_MINIMAL_OPERATIONAL_VALUE && time >= this.changeValues) {
            //Change amplitude:
            this.time = time;
            this.draw();
        }
    };
    //#endregion
    //--------------------------------------------------------
    //----------------   DRAW GRID   -------------------------
    //--------------------------------------------------------
    //#region DRAW GRID
    /**
     * Draw the grid
     */
    DrawECGCanvasClass.prototype.drawGrid = function () {
        var ecgWidth = getSampleGridWidth(this.display, this.configuration) * this.configuration.COLUMNS;
        var ecgHeight = getSampleGridHeight(this.configuration) * this.configuration.ROWS;
        var gridWidth = Math.max(this.width - CANVAS_INITIAL_DRAW_POINT, ecgWidth);
        var gridHeight = Math.max(this.height - CANVAS_INITIAL_DRAW_POINT, ecgHeight);
        var gridBlockSize = this.blockSize;
        var gridCellSize = this.cellSize;
        var gridLineWidth = this.context.lineWidth;
        var gridStrokeStyle = this.context.strokeStyle;
        this.context.strokeStyle = this.configuration.GRID_COLOR;
        var contextInititalValue = 0;
        for (var y = contextInititalValue; y <= gridHeight; y += gridCellSize) {
            this.context.beginPath();
            this.context.lineWidth =
                (y - contextInititalValue) % gridBlockSize ? this.configuration.CELL_WIDTH : this.configuration.BLOCK_WIDTH;
            this.drawLine(contextInititalValue, y, gridWidth, y);
            this.context.closePath();
            this.context.stroke();
        }
        for (var x = contextInititalValue; x <= gridWidth; x += gridCellSize) {
            this.context.beginPath();
            this.context.lineWidth = x % gridBlockSize ? this.configuration.CELL_WIDTH : this.configuration.BLOCK_WIDTH;
            this.drawLine(x, contextInititalValue, x, gridHeight);
            this.context.closePath();
            this.context.stroke();
        }
        this.context.lineWidth = gridLineWidth;
        this.context.strokeStyle = gridStrokeStyle;
    };
    DrawECGCanvasClass.prototype.calcPercentageByPosition = function (percentage) {
        var _this = this;
        // Get the longest channel in case some channel has more samples than others
        var longestChannel = this.channelsData.reduce(function (longest, current) {
            var sampleData = _this.generateSampleData(current.signalList);
            var longestSampleData = sampleData.length > longest ? sampleData.length : longest;
            return longestSampleData;
        }, 0);
        // Calculate the number of elements to draw based on the percentage
        var numericElements = Math.round((longestChannel * percentage) / CANVAS_ABSOLUTE_VALUE);
        var invertedPosition = longestChannel + numericElements;
        // Calculate the position of the first element to draw
        var position = invertedPosition - longestChannel;
        return position;
    };
    DrawECGCanvasClass.prototype.generateSampleData = function (channelData) {
        var representativeIteration = 14; // Is the representative iteration of the samples, each sample is iterated by that number
        var sampleData = [];
        Array.from(Array(representativeIteration).keys()).map(function () { return sampleData.push.apply(sampleData, channelData); });
        return sampleData;
    };
    DrawECGCanvasClass.prototype.changeDrawPoint = function (percentage) {
        this.startToDrawPoint = this.calcPercentageByPosition(percentage);
        this.draw();
    };
    //Draw I, II, III, aVR, aVL, aVF, V1, V2, V3, V4, V5, V6
    DrawECGCanvasClass.prototype.drawECGIndicators = function () {
        switch (this.display) {
            case ECG_DISPLAY_OPTIONS['4x2.5r']:
                this.configuration.ROWS = 4;
                this.configuration.COLUMNS = 4;
                this.margin = 50;
                this.configuration.columnsText = this.getDisposition4x2_5rColumnTexts();
                break;
            default:
                break;
        }
        return this.drawPositions();
    };
    DrawECGCanvasClass.prototype.getDisposition4x2_5rColumnTexts = function () {
        var _a;
        var arrayIndex = 0;
        var columnTexts = [[], [], [], []];
        for (var columnIndex = 0; columnIndex < this.configuration.COLUMNS; columnIndex++) {
            for (var rowIndex = 0; rowIndex < this.configuration.ROWS; rowIndex++) {
                var channel = ((_a = this.channelsData[arrayIndex]) === null || _a === void 0 ? void 0 : _a.channel) || '';
                if (!channel.length && rowIndex === 0 && columnIndex === 3)
                    channel = ECG_CHANNELS.II;
                columnTexts[rowIndex][columnIndex] = channel;
                arrayIndex++;
            }
        }
        return columnTexts;
    };
    DrawECGCanvasClass.prototype.drawDelimiterLines = function () {
        var _this = this;
        if (!this.positionsDraw)
            return;
        var heights = Array.from(new Set(__spreadArray([], this.positionsDraw.map(function (position) { return position.height; }), true)));
        var widths = Array.from(new Set(__spreadArray([], this.positionsDraw.map(function (position) { return position.width; }), true)));
        var gridStrokeStyle = this.context.strokeStyle;
        var sampleSectionHeight = getSampleGridHeight(this.configuration);
        var gridWidth = getSampleGridWidth(this.display, this.configuration) * this.configuration.COLUMNS - CANVAS_INITIAL_DRAW_POINT;
        var gridHeight = sampleSectionHeight * this.configuration.COLUMNS - CANVAS_INITIAL_DRAW_POINT;
        var sampleHeight = sampleSectionHeight / CANVAS_MIDDLE_FACTOR;
        this.context.strokeStyle = '#FF5C61';
        heights.forEach(function (height, heightIndex) {
            var marginHeight = height + sampleHeight;
            _this.context.beginPath();
            _this.context.lineWidth = 1;
            // Add final border
            if (heightIndex === heights.length - 1) {
                _this.drawLine(0, 0, gridWidth, 0);
                _this.context.closePath();
            }
            _this.drawLine(0, marginHeight, gridWidth, marginHeight);
            _this.context.closePath();
            _this.context.stroke();
        });
        widths.forEach(function (width, widthIndex) {
            var marginWidth = width - MARGIN_COLUMN_GAP;
            var penultimateHeight = heights.at(-CANVAS_MIDDLE_FACTOR) || 0;
            var penultimateHeightValue = _this.display === ECG_DISPLAY_OPTIONS['4x2.5r'] ? penultimateHeight + sampleHeight : gridHeight;
            _this.context.beginPath();
            _this.context.lineWidth = 1;
            // Add final border
            if (widthIndex === widths.length - 1) {
                _this.drawLine(gridWidth, 0, gridWidth, sampleSectionHeight * _this.configuration.COLUMNS);
                _this.context.closePath();
            }
            _this.drawLine(marginWidth, 0, marginWidth, penultimateHeightValue);
            _this.context.closePath();
            _this.context.stroke();
        });
        this.context.strokeStyle = gridStrokeStyle;
    };
    //#endregion
    //--------------------------------------------------------
    //----------------    DRAW ECG   -------------------------
    //--------------------------------------------------------
    DrawECGCanvasClass.prototype.drawPositions = function () {
        var columns = this.configuration.COLUMNS;
        var rows = this.configuration.ROWS;
        var gridWidth = getSampleGridWidth(this.display, this.configuration);
        var gridHeight = getSampleGridHeight(this.configuration);
        var marginWidth = 10;
        this.context.font = '400 17px Inter';
        //Inicialize array:
        this.positionsDraw = [];
        //COLUMNS:
        for (var element = 0; element < columns; element++) {
            var middleHeight = gridHeight / CANVAS_MIDDLE_FACTOR;
            //ROWS:
            for (var index = 0; index < rows; index++) {
                var sampleHeight = gridHeight / CANVAS_MIDDLE_FACTOR;
                var factorialHeight = 3;
                var marginHeight = middleHeight - sampleHeight + MARGIN_COLUMN_GAP * factorialHeight;
                this.context.fillText(this.configuration.columnsText[element][index], marginWidth, marginHeight);
                //Save positions for drawECG:
                var position = {
                    name: this.configuration.columnsText[element][index],
                    width: marginWidth,
                    height: middleHeight,
                };
                this.positionsDraw.push(position);
                middleHeight += gridHeight;
            }
            marginWidth += gridWidth;
        }
    };
    /**
     * Draw lines.
     */
    DrawECGCanvasClass.prototype.drawECG = function () {
        var _this = this;
        var _a;
        var columnConunter = 0;
        (_a = this.positionsDraw) === null || _a === void 0 ? void 0 : _a.forEach(function (objPosition, codeIndex) {
            var code = objPosition.name.split(' ')[0];
            var channel = _this.channelsData.find(function (channel) { return channel.channel === code; });
            if (!objPosition || !channel)
                return;
            //Variables:
            var time = 0;
            var index = 0;
            //Reference to draw:
            var startY = objPosition === null || objPosition === void 0 ? void 0 : objPosition.height;
            var startX = (objPosition === null || objPosition === void 0 ? void 0 : objPosition.width) - MARGIN_COLUMN_GAP;
            // 10mm = 1 mV
            var sampleHeight = _this.configuration.AMPLITUDE * 100 * _this.configuration.CELL_SIZE;
            var latestPosition = null;
            //Load data:
            var allSamplesData = _this.generateSampleData(channel.signalList);
            var isRythm = code === ECG_CHANNELS.II && codeIndex === 3 && _this.display === ECG_DISPLAY_OPTIONS['4x2.5r']; // this.getSampleSpace(startX, isRythm);
            var sampleWidth = getSampleGridWidth(_this.display, _this.configuration);
            var space = isRythm ? sampleWidth * _this.configuration.COLUMNS : sampleWidth;
            //Line options:
            _this.context.lineWidth = _this.configuration.CURVE_WIDTH;
            _this.context.lineCap = 'round';
            var sampleWidthInSeconds = 2.5; // For this display option the size of ecg sample is 2.5 seconds.
            //Draw line:
            var samplingFrequency = _this.dataMg.samplingFrequency;
            if (codeIndex !== 0 && codeIndex % _this.configuration.COLUMNS === 0) {
                columnConunter += 1;
            }
            var sectionPosition = isRythm ? 0 : columnConunter * sampleWidthInSeconds;
            var samplesStartPoint = sectionPosition * samplingFrequency;
            var samplesListLenght = getSampleWidthInSeconds(_this.display) * samplingFrequency;
            var samplesEndPoint = isRythm
                ? samplesListLenght * _this.configuration.COLUMNS
                : samplesStartPoint + samplesListLenght;
            var sampleData = allSamplesData.slice(samplesStartPoint + SAMPLE_START_OFFSET, samplesEndPoint + SAMPLE_START_OFFSET);
            var stepInTime = space / sampleData.length;
            if (latestPosition === null) {
                var firstValue = sampleData[0] * sampleHeight;
                latestPosition = startY - firstValue;
            }
            while (time < space) {
                //10mV/s:
                var point = sampleData[index] * sampleHeight; //Rescalate. 10mV/s Each square is 1 mm.
                //Draw line:
                _this.context.beginPath();
                _this.drawLine(startX + time, latestPosition, startX + time, startY - point);
                _this.context.stroke();
                //Positions:
                latestPosition = startY - point;
                //25mm/s:
                time += stepInTime; //25mm/s Each square is 1 mm
                index++;
            }
        });
        //Clear data:
        this.positionsDraw = [];
    };
    return DrawECGCanvasClass;
}(GenericCanvasClass));
export { DrawECGCanvasClass };
var getRoundedValue = function (value) { return Math.round(value * CANVAS_ABSOLUTE_VALUE) / CANVAS_ABSOLUTE_VALUE; };
//# sourceMappingURL=DrawECGCanvasClass.js.map